import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ReactTemplate } from '@bingads-webui-react/react-template';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getStyles } from './shared-styles';

export const getRedirectUrl = ({
  shouldReload,
  isFluentNewUI,
  context: {
    accountId,
    customerId,
    userId,
  },
}) => {
  if (shouldReload) return window.location.href;
  const path = isFluentNewUI ? '/campaign/vnext' : '/Campaign/Campaigns';
  const suffix = isFluentNewUI ? '' : `#customer/${customerId}/account/${accountId}/campaign`;
  return `${path}?&cid=${customerId}&uid=${userId}&aid=${accountId}&didSwitchToExpert=1${suffix}`;
};

export class SwitchExpertFormUnstyled extends React.PureComponent {
  static propTypes = {
    shouldReload: PropTypes.bool.isRequired,
    isFluentNewUI: PropTypes.bool.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
      getCldr: PropTypes.func,
    }).isRequired,
    context: PropTypes.shape({
      accountId: PropTypes.number,
      customerId: PropTypes.number,
      userId: PropTypes.number,
    }).isRequired,
    classes: PropTypes.shape({
      linkText: PropTypes.string,
      modalHeader: PropTypes.string,
      formBody: PropTypes.string,
      formPoint: PropTypes.string,
      closeButton: PropTypes.string,
      linkContainer: PropTypes.string,
      learnMore: PropTypes.string,
      bodyLabel: PropTypes.string,
      button: PropTypes.string,
    }).isRequired,
  }

  handleSubmit = () => this.props.onSuccess().then(() => {
    window.location.href = getRedirectUrl({
      shouldReload: this.props.shouldReload,
      isFluentNewUI: this.props.isFluentNewUI,
      context: this.props.context,
      onSuccess: this.props.onSuccess,
    });
  })

  handleCancel = () => this.props.onCancel()

  render() {
    return (
      <div className="switch-expert-form" >
        <div className="switch-expert-form-header">
          <button className={classNames('close', this.props.classes.closeButton)} aria-label={this.props.i18n.getString('SwitchForm_Close')} onClick={this.handleCancel}>
            <span aria-hidden="true" className="closeimage" />
          </button>
          <div className={this.props.classes.modalHeader}>{this.props.i18n.getString('SwitchExpertModal_Header')}</div>
        </div>

        <div className={classNames('switch-expert-form-body', this.props.classes.formBody)}>
          <div className={this.props.classes.bodyLabel}>
            {this.props.i18n.getString('SwitchExpertModal_BodyLabel')}
          </div>
          <ul className="form-body">
            <li className={this.props.classes.formPoint}>{this.props.i18n.getString('SwitchExpertModal_Feature1')}</li>
            <li className={this.props.classes.formPoint}>{this.props.i18n.getString('SwitchExpertModal_Feature2')}</li>
            <li className={this.props.classes.formPoint}>{this.props.i18n.getString('SwitchExpertModal_Feature3')}</li>
          </ul>
          <div
            className={classNames(this.props.classes.linkContainer, this.props.classes.formBody)}
          >
            <ReactTemplate
              model={{
                b: text => (
                  <button className={classNames('HelpTopic', 'btn-link', this.props.classes.learnMore)} query="app54662">{text}</button>),
              }}
              template={`{{b}}${this.props.i18n.getString('SwitchExpertModal_LinkLearnMore')}{{/b}}`}
            />
          </div>
        </div>

        <div className="form-group">
          <button
            data-analyticsid="switch-expert-modal_cancel"
            className={classNames('btn', 'btn-primary', this.props.classes.button)}
            onClick={this.handleCancel}
          >
            {this.props.i18n.getString('SwitchExpertModal_ButtonStay')}
          </button>
          <button
            data-analyticsid="switch-expert-modal_confirm"
            className={classNames('btn', 'btn-default', this.props.classes.button)}
            onClick={this.handleSubmit}
          >
            {this.props.i18n.getString('SwitchExpertModal_ButtonSwitch')}
          </button>
        </div>
      </div>
    );
  }
}

// here we export 2 components because this modal will
// render it self as child of document.body which is outside of app
// so it cannot read react-jss theme info
export const SwitchExpertForm = withDefaultStyles(
  SwitchExpertFormUnstyled,
  getStyles()
);

export const FluentSwitchExpertForm = withDefaultStyles(
  SwitchExpertFormUnstyled,
  getStyles(true)
);
